import React from "react";

const FleetListCard = ({ vessel }) => {
  return (
    <div className="fleet-list-card">
      <a className="image-link" href={vessel.link} target="_parent">
        <img
          className="fleet-list-img"
          src={
            vessel.yoast_head_json.og_image
              ? vessel.yoast_head_json.og_image[0].url
              : "/wp-content/uploads/2024/07/Chartering.jpg"
          }
          alt="vessel"
        />
      </a>
      <div className="fleet-list-inner">
        <span className="fleet-list-category">{vessel.acf.operator}</span>{" "}
        <span className="text-gray">(OPERATOR)</span>
        <h3 className="fleet-list-title">{vessel.title.rendered}</h3>
        <div className="vessel-sepcs">
          <div className="vessel-spec">
            <div className="vessel-spec-inner">
              <span className="spec-gray">Built</span>
              <span className="spec-bold">{vessel.acf.built}</span>
            </div>
          </div>
          <div className="vessel-spec">
            <div className="vessel-spec-inner">
              <span className="spec-gray">DWAT</span>
              <span className="spec-bold">{vessel.acf.dwat}</span>
            </div>
          </div>
          <div className="vessel-spec">
            <div className="vessel-spec-inner">
              <span className="spec-gray">Capacity</span>
              <span className="spec-bold">{vessel.acf.capacity}</span>
            </div>
          </div>
          <div className="vessel-spec">
            <div className="vessel-spec-inner">
              <span className="spec-gray">Geared</span>
              <span className="spec-bold">{vessel.acf.geared}</span>
            </div>
          </div>
        </div>
        <div className="card-buttons">
          <a className="more-info-btn" href={vessel.link} target="_parent">
            More info
          </a>
          <a
            className="downloads-specs-btn"
            target="_blank"
            rel="noreferrer"
            href={vessel.acf.download_specs}
          >
            Download specs <i className="fa-solid fa-cloud-arrow-down"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default FleetListCard;
